import style from "../slider.module.scss";
import { ReactComponent as ShareIcon } from "../../assets/icons/share.svg";
import { ReactComponent as TriangleVideoIcon } from "../../assets/icons/triangle-video.svg";
import { useState } from "react";
import ShareTooltip from "../../share-tooltip/share-tooltip";

const SliderCard = ({ video, swiperRef, slideIndex }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const handleShare = () => {
    setShowTooltip(!showTooltip);
  };

  // Go to current slide when share clicked
  const goToCurrentSlide = () => {
    if (swiperRef.current) {
      swiperRef.current.slideTo(slideIndex);
    }
  };

  return (
    <>
      <div className={style.card}>
        <div className={style.imageContainer}>
          <img src={video.thumbnail.url} alt={video.thumbnail.alt} />
          <TriangleVideoIcon className={style.icon} />
        </div>
        <div>
          <p className={style.title}>{video.title}</p>
          <div className={style.share} onClick={goToCurrentSlide}>
            <p className={style.duration}>5 min</p>
            <span>•</span>

            <div className={style.buttonContainer}>
              <button onClick={handleShare}>
                <ShareIcon />
                Partager
              </button>

              <ShareTooltip
                showTooltip={showTooltip}
                setShowTooltip={setShowTooltip}
                text={video.title}
                url={`https://youtube.com/watch?v=${video.video_id}`}
              />
            </div>
          </div>
          <div
            className={style.content}
            dangerouslySetInnerHTML={{
              __html: video.content || "",
            }}
          ></div>
        </div>
      </div>
    </>
  );
};

export default SliderCard;
